import { render } from "./TableDemo.vue?vue&type=template&id=2262f98d&scoped=true"
import script from "./TableDemo.vue?vue&type=script&lang=js"
export * from "./TableDemo.vue?vue&type=script&lang=js"

import "./TableDemo.vue?vue&type=style&index=0&id=2262f98d&scoped=true&lang=scss"

import exportComponent from "D:\\CTS_SURAJ\\City Hoardings\\City_Hoardings_Eticket\\ui-code\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2262f98d"]])

export default __exports__